import Router from './router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import WebApp from '@twa-dev/sdk';
import { useEffect } from 'react';
import { UAParser } from 'ua-parser-js';
import styles from './app.module.scss';
import { useToast } from '@/store/useToast';
import { eventsApi } from '@/api';
import { jwtService } from '@/services/jwt.service';
import { useVibration } from './store/useVibration';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false
        },
    },
});

const isIOS = () => {
    if (typeof window === `undefined` || typeof navigator === `undefined`)
        return false;

    return /iPhone|iPad|iPod/i.test(
        navigator.userAgent ||
            navigator.vendor ||
            ((window as any).opera && (window as any).toString() === `[object Opera]`),
    );
};

/**
 * хак для iOS при фокусе в инпут, выравнивает вебвью
 */
const hackForFocusInputOnIOS = () => {
    WebApp.onEvent('viewportChanged', () => {
        // if (WebApp.platform === 'ios') {
        //     window.scrollTo({ top: 0, behavior: 'auto' });
        // }

        WebApp.expand();
        console.log('viewportChanged');

        if (window.visualViewport) {
            console.log('window.visualViewport.height', window.visualViewport.height);
        }
    });
};

const addClassForPlatform = () => {
    document.documentElement.classList.add(WebApp.platform);
    if (isIOS()) {
        document.documentElement.classList.add('web-ios');
    }
};

const handleViewportChange = () => {
    if (window.visualViewport) {
        // const viewportHeight = window.visualViewport.height;
        // Логика подстройки интерфейса
        console.log('start handleViewportChange', window.visualViewport.height, WebApp.platform);

        //console.log(window.innerHeight - window.visualViewport.height)

        // @ts-ignore
        // let newMargin = (window['baseHeight'] || window.visualViewport.height) - window.visualViewport.height;
        // document.body.style.marginBottom = newMargin + 'px';
        // console.log('newMargin', newMargin);

        if (isIOS()) {
            // window.scrollTo({ top: 0, behavior: 'auto' });
            // window.scrollTo(0, 0);
            // document.body.scrollTop = 0;

            const activeElement = document.activeElement;

            // Проверяем, является ли активный элемент input или textarea
            if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
                console.log('activeElement', activeElement);
                // Плавно скроллим к активному элементу
                activeElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center', // или 'nearest'
                });
            }
        }

        WebApp.expand();
    }
};

jwtService.initToken();

let sendSessionEvent = (eventType: string) => {
    const authHeader = jwtService.getAuthHeader();

    const url = `/api/events/`;

    const data = { event_type: { event: eventType } };


    const blob = new Blob([JSON.stringify(data)], {
        type: 'application/json',
    });

    fetch(url, {
        method: 'POST',
        body: blob,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': authHeader,
        },
        keepalive: true,
    });
};

let useTelegramVisibilityEvents = () => {
    useEffect(() => {
        if (!window.Telegram?.WebApp.initData.length) return;

        eventsApi.updateUserEvent('session_start');

        const handleClose = () => {
            sendSessionEvent('session_end');
        };

        //sendSessionEvent('session_end');

        window.addEventListener('beforeunload', handleClose);
        WebApp.onEvent('viewportChanged', (isStateVisible) => {
            if (!isStateVisible) handleClose();
        });
        WebApp.onEvent('deactivated', () => {
            handleClose();
        });

        return () => {
            window.removeEventListener('beforeunload', handleClose);
            handleClose();
        };
    }, []);
}

export const App = () => {
    useTelegramVisibilityEvents();

    const { setVibrationEnabled } = useVibration(state => state)
    
    useEffect(() => {
        WebApp.ready();
        WebApp.disableVerticalSwipes();
        WebApp.BackButton.isVisible = true;
        WebApp.BackButton.show();
        WebApp.expand();
        addClassForPlatform();
        hackForFocusInputOnIOS();

        // @ts-ignore
        window['baseHeight'] = window.innerHeight;

        const parser = new UAParser();
        const device = parser.getDevice();

        try {
            document.documentElement.classList.add('app-fullscreen');
            document.documentElement.classList.add(`app-fullscreen--${device.type}`);
            //WebApp.requestFullscreen();

            if (device.type === 'mobile') {
                WebApp.requestFullscreen();
                document.documentElement.classList.add('app-fullscreen');
            }
        } catch (e) {
            console.warn(e);
        }

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', handleViewportChange);
        }

        const VIBRATION_ENABLED =
            localStorage.getItem('VIBRATION_ENABLED')
        if (VIBRATION_ENABLED)
            setVibrationEnabled(
                VIBRATION_ENABLED == 'true'
            )
        else
            setVibrationEnabled(true)

        return () => {
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', handleViewportChange);
            }
        };
    }, []);

    const toast = useToast((state) => state.toast);
    const isShown = useToast((state) => state.isShown);
    const setToastDissapearAnim = useToast((state) => state.setToastDissapearAnim);

    useEffect(() => {
        if (isShown === false)
            setToastDissapearAnim(
                document
                    .querySelector(`.${styles.toast}`)
                    ?.animate([
                        {
                            opacity: 1.0
                        },
                        {
                            opacity: 0.0
                        }
                    ], {
                        duration: 1000
                    })
            )
    }, [isShown])

    return (
        <QueryClientProvider client={queryClient}>
            <Router />
            {
                toast &&
                <div className={styles.toast} style={{ bottom: toast.bottom || 100 }}>
                    {/* Кастомная позиция */}
                    <div
                        className={styles.toastContent}
                        style={{
                            backgroundColor: toast.backgroundColor || '#000',
                            color: toast.textColor || '#fff'
                        }}>
                        {toast?.icon ?? <></>}
                        <span>{toast?.msg}</span>
                    </div>
                </div>
            }
        </QueryClientProvider>
    );
};
